export * from './lib/audio-player-feature-shell.module';
